import { projectIs } from "@/lib/feature-flags/featureFlagsDeside.helpers";
import { pickFirstTrueMatchingValue } from "@/utils/pickFirstTrueMatchingValue.utils";

export const searchPageMeta = pickFirstTrueMatchingValue([
  [
    projectIs(["GM"]),
    {
      title: "Find Gorgeous Singles at ❤️ GoldenMeets",
      description:
        "Search and Meet Gorgeous Singles at GoldenMeets ✅ International Singles Ready for New Relationships and Fun",
    },
  ],
  [
    true,
    {
      title: "Ukraine Brides Search - Find Ukraininan Women Now",
      description: `Ukraine Brides Search Engine ➤ Try it! ✔100% Verified Profiles\
            ✔Free Registration ✔Safe & Secure ➤ Your Dream Wife Is Waiting At GoldenBride.net ➤ Join Us!`,
    },
  ],
]);
